import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ProviderOrderFieldComponent } from './provider-order-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    ProviderOrderFieldComponent,
  ],
  exports: [
    ProviderOrderFieldComponent,
  ],
})
export class ProviderOrdersExportModule {}
